'use strict';

var OOP = require('utils/oop');
var Utils = {};

var Mixins = {
    SelectableCollection: {
        // Check all contained models whether they are selectable
        // or not -> return number of actual selectable models.
        selectableLength: function () {
            return _.filter(this.models, function (model) {
                // Return 'true' if model is explicitly set to
                // "selectable" or 'selectable' is undefined.
                return !(model.selectable === false);
            }).length;
        },

        // Toggle state of all selectable models.
        toggleAllSelectable: function () {
            if (this.selectedLength != this.selectableLength()) {
                this.selectAll();
            } else {
                this.deselectAll();
            }
        },

        // Called as soon as all models are selected
        // -> deselect all models that are not selectable.
        // The only way for the user to "select unselectable models"
        // is via the "select-all" checkbox. This method fixes the
        // actual selection.
        onSelectAll: function (options) {
            _.each(options.selected, function (model) {
                if (model.selectable === false) {
                    model.deselect();
                }
            });
        },
    },
};

Utils.SelectableModel = {
    applyTo: function (model, isSelectable) {
        Backbone.Select.Me.applyTo(model);
        model.selectable = isSelectable;
    },
};

Utils.SelectableCollection = {
    applyTo: function (collection, options) {
        Backbone.Select.Many.applyTo(collection, [], options);
        _.extend(collection, Mixins.SelectableCollection);
    },
};

Utils.CreateStdModel = function (def) {
    var get = function (src, key, defaultValue) {
        return (src || {})[key] || (def.both || {})[key] || defaultValue;
    };

    var createDef = function (src) {
        var d = _.clone(def.both || {});
        _.each(src, function (value, key) {
            d[key] = value;
        });
        return d;
    };

    var modelDef = createDef(def.model);
    modelDef.initialize = function () {
        this.base.initialize();
        var initFct = get(def.model, 'initialize', function () {});
        initFct.apply(this, arguments);
        if (!def.noSelect && !def.noSelectModel) {
            Backbone.Select.Me.applyTo(this);
        }
    };
    var model = OOP.extend(Backbone.Model, modelDef);

    var collectionDef = createDef(def.collection);
    collectionDef.model = model;
    collectionDef.initialize = function () {
        this.base.initialize();
        var initFct = get(def.collection, 'initialize', function () {});
        initFct.apply(this, arguments);
        if (!def.noSelect && !def.noSelectCollection) {
            Utils.SelectableCollection.applyTo(this);
        }
    };
    return {
        Model: model,
        Collection: OOP.extend(Backbone.Collection, collectionDef),
    };
};

module.exports = Utils;
